import AsyncImage from "../core/AsyncImage";
import ResizableScene from "../core/ResizableScene";


export default class AsyncDraggableButton extends AsyncImage {
	static readonly ON_POINTER_DOWN = "onPointerDown";
	static readonly ON_CLICK = "onClick";

	static readonly ON_DRAG = "onDrag";
	static readonly ON_DRAG_START = "onDragStart";
	static readonly ON_DRAG_END = "onDragEnd";

	events: Phaser.Events.EventEmitter;

	protected lastMousePoint: Phaser.Math.Vector2;
	protected dragDistance = 0;
	protected minDragDistance = 20;

	private _draggingEnabled = true;
	private _buttonClickEnabled = true;

	private _dragging = false;
	private _pointerDown = false;
	private _pointerOver = false;

	// protected transformControls: Phaser.GameObjects.Container;

	constructor(scene: ResizableScene, x: number, y: number, path: string, img: string) {
		super(scene, x, y, path, img);
		this.events = new Phaser.Events.EventEmitter();
		if (this.status != "loaded") {
			this.on(AsyncImage.LOAD_COMPLETE, () => this.setInteractive(), this);
		} else {
			this.setInteractive();
		}

		this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, this.onPointerOver, this);
		this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, this.onPointerOut, this);
		this.scene.input.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onPointerUp, this);
	}

	enableDrag(enable: boolean): void {
		this._draggingEnabled = enable;
	}

	get dragEnabled(): boolean {
		return this._draggingEnabled;
	}

	enableButton(enable: boolean): void {
		this._buttonClickEnabled = enable;
	}

	get buttonEnabled(): boolean {
		return this._buttonClickEnabled;
	}

	startDrag(ptr: Phaser.Input.Pointer, forceDrag = false): void {
		this._pointerDown = true;
		this._dragging = true;
		this.emit(AsyncDraggableButton.ON_DRAG_START, ptr, this);

		if (forceDrag) {
			this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
		}
		this.scene.input.once(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
	}

	endDrag(ptr: Phaser.Input.Pointer): void {
		// this.stopDragListener();
		this._pointerDown = false;
		this._dragging = false;
		this.emit(AsyncDraggableButton.ON_DRAG_END, ptr, this);
	}

	onPointerDown(ptr: Phaser.Input.Pointer): void {
		// On Pointer Down
		this._pointerDown = true;
		this.dragDistance = 0;
		this.lastMousePoint = new Phaser.Math.Vector2(ptr.x, ptr.y);
		console.log("onPointerDown");

		this.emit(AsyncDraggableButton.ON_POINTER_DOWN, ptr, this);
		this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
	}

	onPointerMove(ptr: Phaser.Input.Pointer): void {
		if (this._draggingEnabled && this._pointerDown) {
			if (!this._dragging) {
				const point = new Phaser.Math.Vector2(ptr.x, ptr.y);
				this.dragDistance += Math.abs(Phaser.Math.Distance.BetweenPoints(this.lastMousePoint, point));
				if (this.dragDistance >= this.minDragDistance) this.startDrag(ptr);
			}

			if (this._dragging) {
				this.emit(AsyncDraggableButton.ON_DRAG, ptr, this);
			}
		}
	}

	onPointerUp(ptr: Phaser.Input.Pointer): void {
		if (this._buttonClickEnabled && !this._dragging && this._pointerDown && this._pointerOver) {
			this.emit(AsyncDraggableButton.ON_CLICK, ptr, this);
		} else if (this._draggingEnabled && this._pointerDown && this._dragging) {
			this.endDrag(ptr);
		}

		if (this.scene) {
			this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
		}
		this._pointerDown = false;
	}

	enableInput(enable: boolean): void {
		this._draggingEnabled = enable;
		this._buttonClickEnabled = enable;
		this._dragging = false;
		this._pointerDown = false;
		if (enable) this.setInteractive();
		else this.disableInteractive();
	}

	destroy(): void {
		this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		if (this.scene) {
			this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
			this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
			this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.endDrag, this);
		}
		super.destroy();
	}

	onPointerOver(): void {
		this._pointerOver = true;
	}

	onPointerOut(): void {
		this._pointerOver = false;
	}
}
